import { services } from './v1/services'

export const API = {
    v1: {
        services,
    },
}
